import { createContext } from 'react';
import { Skill } from 'src/models/skill';

export interface SkillContextType {
  hasLoadedBasicData: boolean;
  loadSkillsWithBasicData: () => Promise<void>;
  skillsWithBasicData: Omit<Skill, 'items'>[];
  getSkillsWithBasicData: () => Omit<Skill, 'items'>[];
  getSkillById: (skillId: string) => Skill | null;
  createSkill: (skill: Omit<Skill, '_id' | 'organization'>) => Promise<[string | null, string | null]>;
  editSkill: (skill: Partial<Skill> & { _id: string }) => Promise<string | null>;
  deleteSkill: (skillId: string) => Promise<string | null>;
  setSkillCache: (skill: Skill) => void;
}

export const SkillContext = createContext<SkillContextType>({} as SkillContextType);
